exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.record[data-v-45ce16d3] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n}\n.record .left-col[data-v-45ce16d3] {\n    width: 200px;\n}\n.record .right-col[data-v-45ce16d3] {\n    width: calc(100% - 200px);\n}\n.record .right-col .button[data-v-45ce16d3] {\n      background: #fffacd;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-45ce16d3","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ChatBot/organisms/ChatBotData.vue
// module id = OuE/
// module chunks = 0